module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5WQxC0/tc-custom/9781612438887.jpg?1700746446301",
      "alt": "This image is the cover for the book Fearless Flourishing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fearless Flourishing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Take your lettering to the next level with beautiful, stylish flourishes.")]), _c('br'), _c('br'), _vm._v(" You’ve mastered every letter, from capital A to lowercase z. Now you want your hand-drawn projects to have the ornate and extravagant look that is only achieved through flourishing. Whether you go for a delicate, stately, whimsical, bold, funky, or elegant look, flourishing is a wonderful way to develop a personal style and make your hand-lettering stand out. From basic theories and helpful practices to beautiful examples and complex compositions, this step-by-step workbook provides all the tools you need to flourish with confidence!"), _c('br'), _c('br'), _c('b', [_vm._v("• Elegant Letter Embellishments"), _c('br'), _vm._v(" • Fanciful Flourishes & Filigree"), _c('br'), _vm._v(" • Decorative Borders & Frames")]), _c('br'), _c('b', [_vm._v("• Stylish Artistic Elements")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alissa Chojnacki\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0